export default "__VITE_ASSET__CSXOxvbe__"